package nl.astraeus.midi

import kotlin.math.max
import kotlin.math.min
import kotlin.math.pow
import kotlin.math.round

/**
 * User: rnentjes
 * Date: 14-11-15
 * Time: 11:50
 */

enum class Note(
  val sharp: String,
  val flat: String,
  val sharpPos: Int,
  val flatPos: Int,
  val blackKey: Boolean = false
) {
  NO01("C--", "C--", 35, 35),
  NO02("C#-", "Db-", 35, 34, true),
  NO03("D--", "D--", 34, 34),
  NO04("D#-", "Eb-", 34, 33, true),
  NO05("E--", "E--", 33, 33),
  NO06("F--", "F--", 32, 32),
  NO07("F#-", "Gb-", 32, 31, true),
  NO08("G--", "G--", 31, 31),
  NO09("G#-", "Ab-", 31, 30, true),
  NO10("A--", "A--", 30, 30),
  NO11("A#-", "Bb-", 30, 29, true),
  NO12("B--", "B--", 29, 29),
  C0("C-0", "C-0", 28, 28),
  C0s("C#0", "Db0", 28, 27, true),
  D0("D-0", "D-0", 27, 27),
  D0s("D#0", "Eb0", 27, 26, true),
  E0("E-0", "E-0", 26, 26),
  F0("F-0", "F-0", 25, 25, true),
  F0s("F#0", "Gb0", 25, 24),
  G0("G-0", "G-0", 24, 24),
  G0s("G#0", "Ab0", 24, 23, true),
  A0("A-0", "A-0", 23, 23),
  A0s("A#0", "Bb0", 23, 22, true),
  B0("B-0", "B-0", 22, 22),
  C1("C-1", "C-1", 21, 21),
  C1s("C#1", "Db1", 21, 20, true),
  D1("D-1", "D-1", 20, 20),
  D1s("D#1", "Eb1", 20, 19, true),
  E1("E-1", "E-1", 19, 19),
  F1("F-1", "F-1", 18, 18),
  F1s("F#1", "Gb1", 18, 17, true),
  G1("G-1", "G-1", 17, 17),
  G1s("G#1", "Ab1", 17, 16, true),
  A1("A-1", "A-1", 16, 16),
  A1s("A#1", "Bb1", 16, 15, true),
  B1("B-1", "B-1", 15, 15),
  C2("C-2", "C-2", 14, 14),
  C2s("C#2", "Db2", 14, 13, true),
  D2("D-2", "D-2", 13, 13),
  D2s("D#2", "Eb2", 13, 12, true),
  E2("E-2", "E-2", 12, 12),
  F2("F-2", "F-2", 11, 11),
  F2s("F#2", "Gb2", 11, 10, true),
  G2("G-2", "G-2", 10, 10),
  G2s("G#2", "Ab2", 10, 9, true),
  A2("A-2", "A-2", 9, 9),
  A2s("A#2", "Bb2", 9, 8, true),
  B2("B-2", "B-2", 8, 8),
  C3("C-3", "C-3", 7, 7),
  C3s("C#3", "Db3", 7, 6, true),
  D3("D-3", "D-3", 6, 6),
  D3s("D#3", "Eb3", 6, 5, true),
  E3("E-3", "E-3", 5, 5),
  F3("F-3", "F-3", 4, 4),
  F3s("F#3", "Gb3", 4, 3, true),
  G3("G-3", "G-3", 3, 3),
  G3s("G#3", "Ab3", 3, 2, true),
  A3("A-3", "A-3", 2, 2),
  A3s("A#3", "Bb3", 2, 1, true),
  B3("B-3", "B-3", 1, 1),
  C4("C-4", "C-4", 0, 0),
  C4s("C#4", "Db4", 0, -1, true),
  D4("D-4", "D-4", -1, -1),
  D4s("D#4", "Eb4", -1, -2, true),
  E4("E-4", "E-4", -2, -2),
  F4("F-4", "F-4", -3, -3),
  F4s("F#4", "Gb4", -3, -4, true),
  G4("G-4", "G-4", -4, -4),
  G4s("G#4", "Ab4", -4, -5, true),
  A4("A-4", "A-4", -5, -5),
  A4s("A#4", "Bb4", -5, -6, true),
  B4("B-4", "B-4", -6, -6),
  C5("C-5", "C-5", -7, -7),
  C5s("C#5", "Db5", -7, -8, true),
  D5("D-5", "D-5", -8, -8),
  D5s("D#5", "Eb5", -8, -9, true),
  E5("E-5", "E-5", -9, -9),
  F5("F-5", "F-5", -10, -10),
  F5s("F#5", "Gb5", -10, -11, true),
  G5("G-5", "G-5", -11, -11),
  G5s("G#5", "Ab5", -11, -12, true),
  A5("A-5", "A-5", -12, -12),
  A5s("A#5", "Bb5", -12, -13, true),
  B5("B-5", "B-5", -13, -13),
  C6("C-6", "C-6", -14, -14),
  C6s("C#6", "Db6", -14, -15, true),
  D6("D-6", "D-6", -15, -15),
  D6s("D#6", "Eb6", -15, -16, true),
  E6("E-6", "E-6", -16, -16),
  F6("F-6", "F-6", -17, -17),
  F6s("F#6", "Gb6", -17, -18, true),
  G6("G-6", "G-6", -18, -18),
  G6s("G#6", "Ab6", -18, -19, true),
  A6("A-6", "A-6", -19, -19),
  A6s("A#6", "Bb6", -19, -20, true),
  B6("B-6", "B-6", -20, -20),
  C7("C-7", "C-7", -21, -21),
  C7s("C#7", "Db7", -21, -22, true),
  D7("D-7", "D-7", -22, -22),
  D7s("D#7", "Eb7", -22, -23, true),
  E7("E-7", "E-7", -23, -23),
  F7("F-7", "F-7", -24, -24),
  F7s("F#7", "Gb7", -24, -25, true),
  G7("G-7", "G-7", -25, -25),
  G7s("G#7", "Ab7", -25, -26, true),
  A7("A-7", "A-7", -26, -26),
  A7s("A#7", "Bb7", -26, -27, true),
  B7("B-7", "B-7", -27, -27),
  C8("C-8", "C-8", -28, -28),
  C8s("C#8", "Db8", -28, -29, true),
  D8("D-8", "D-8", -29, -29),
  D8s("D#8", "Eb8", -29, -30, true),
  E8("E-8", "E-8", -30, -30),
  F8("F-8", "F-8", -31, -31),
  F8s("F#8", "Gb8", -31, -32, true),
  G8("G-8", "G-8", -32, -32),
  G8s("G#8", "Ab8", -32, -33, true),
  A8("A-8", "A-8", -33, -33),
  A8s("A#8", "Bb8", -33, -34, true),
  B8("B-8", "B-8", -34, -34),
  C9("C-9", "C-9", -35, -35),
  C9s("C#9", "Db9", -35, -36, true),
  D9("D-9", "D-9", -36, -36),
  D9s("D#9", "Eb9", -36, -37, true),
  E9("E-9", "E-9", -37, -37),
  F9("F-9", "F-9", -38, -38),
  F9s("F#9", "Gb9", -38, -39, true),
  G9("G-9", "G-9", -39, -39),

  // out of midi range
  //G9s("G#9","Ab9"),
  //A9("A-9","A-9"),
  //A9s("A#9","Bb9"),
  //B9("B-9","B-9"),
  NONE("---", "---", 0, 0),
  UP("^^^", "^^^", 0, 0),
  END("XXX", "XXX", 0, 0),
  ;

  val trebblePosSharp = 325.0 + sharpPos * 12.5
  val trebblePosFlat = 325.0 + flatPos * 12.5

  val bassPosSharp = 175.0 + sharpPos * 12.5
  val bassPosFlat = 175.0 + flatPos * 12.5

  // 69 = A4.ordinal
  val freq: Double = round(440.0 * 2.0.pow((ordinal - 69) / 12.0)) // * 10000.0) / 10000.0
  val cycleLength: Double = 1.0 / freq
  var sampleDelta: Double = 0.0

  fun transpose(semiNotes: Int): Note = if (ordinal >= C0.ordinal && ordinal <= G9.ordinal) {
    var result = this.ordinal + semiNotes

    result = min(result, G9.ordinal)
    result = max(result, C0.ordinal)

    fromMidi(result)
  } else {
    this
  }

  companion object {
    fun fromMidi(midi: Int): Note {
      // todo: add check
      return entries[midi]
    }

    fun updateSampleRate(rate: Int) {
      println("Setting sample rate to $rate")
      for (note in Note.entries) {
        note.sampleDelta = (1.0 / rate.toDouble()) / note.cycleLength
      }
    }
  }
}

// freq = 10Hz
// cycleLength = 0.1
// sampleRate = 48000
// sampleDelta = 4800

// (1.0 / freq) * sampleRate
